import { Box } from "@mui/material";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import SalesForm from "../../../components/SalesForm";
import Header from "../../../components/Header";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const CreateInvoices = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const apiUrl = "https://oven-backend.onrender.com";


  const handleFormSubmit = async (values) => {
    try {
      const formattedValues = {
        employee_id: values.employee_id,
        products: values.products.map((product) => ({
          name_sales: product.name_sales,
          quantity: Number(product.quantity),
          price: Number(product.price),
        })),
        payment_status: values.payment_status,
        inventory_status: values.inventory_status,
        date: values.date || new Date().toISOString(),
      };

      await axios.post(`${apiUrl}/sales`, formattedValues);
      setOpen(true);
      setTimeout(() => {
        navigate("/invoices");
      }, 1000);
    } catch (error) {
      console.error(t('create_sale_error'), error.response?.data || error);
    }
  };

  return (
    <Box m="20px" sx={{ direction: isRTL ? 'rtl' : 'ltr' }}>
      <Header 
        title={t('create_sales')} 
        subtitle={t('create_sales_subtitle')} 
      />

      <SalesForm 
        initialValues={{
          employee_id: "",
          products: [{ name_sales: "", quantity: "", price: "" }],
          payment_status: "",
          inventory_status: "",
          date: "",
        }}
        handleFormSubmit={handleFormSubmit} 
        buttonLabel={t('add_sale')}
      />

      <Snackbar open={open} autoHideDuration={6000} onClose={() => setOpen(false)}>
        <Alert
          onClose={() => setOpen(false)}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          {t('success_added_sale')}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateInvoices;